import { EnumBase } from 'hay-core-react';
class TemplateTestebandaEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.testebanda.cloudflare',
        'main.monitoramentotemplate.testebanda.desativado',
      ],
      'main.monitoramentotemplate.testebanda.desativado'
    );
  }
}

export default new TemplateTestebandaEnum();
